import { ReactNode } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageHero from "@/components/PageHero";

interface LegalLayoutProps {
  eyebrow: string;
  title: string;
  updated: string;
  children: ReactNode;
}

const LegalLayout = ({ eyebrow, title, updated, children }: LegalLayoutProps) => (
  <div className="min-h-screen bg-background">
    <Navbar />
    <PageHero eyebrow={eyebrow} title={title} subtitle={`Last updated: ${updated}`} size="sm" />
    <section className="container mx-auto px-4 py-20 max-w-3xl">
      <article className="prose prose-neutral max-w-none prose-headings:font-display prose-headings:font-semibold prose-h2:text-2xl prose-h2:mt-12 prose-h3:text-xl prose-a:text-primary prose-strong:text-foreground prose-li:my-1">
        {children}
      </article>
    </section>
    <Footer />
  </div>
);

export default LegalLayout;
